import { z } from 'zod';
import { EntityIdSchema, IsoDateTimeSchema } from './common.js';
export const EventTypeSchema = z.enum([
    'WORK_ITEM_CREATED',
    'WORK_ITEM_CONTINUED',
    'WORK_ITEM_INPUT_ADDED',
    'DELIVERY_FEEDBACK_RECORDED',
    'SANDBOX_PROVISIONING',
    'SANDBOX_READY',
    'SANDBOX_RECLAIMED',
    'PACKAGES_DEDUPLICATED',
    'WORKFLOW_STARTED',
    'WORKFLOW_RECOVERED',
    'STAGE_STARTED',
    'STAGE_OUTPUT',
    'STAGE_COMPLETED',
    'STAGE_FAILED',
    'WORKFLOW_RESULT_NORMALIZED',
    'WORKFLOW_DECISION_POLICY_CHANGED',
    'WORKFLOW_DECISION_REQUESTED',
    'WORKFLOW_DECISION_RESOLVED',
    'WORKFLOW_INTERRUPT_REQUESTED',
    'WORKFLOW_CANCEL_REQUESTED',
    'STAGE_INTERRUPTED',
    'WORKFLOW_RESTARTED_AFTER_INPUT',
    'WORKFLOW_RUN_CONTEXT_PREPARED',
    'WORKFLOW_REPOSITORY_SELECTION_RESTORED',
    'WORKFLOW_ROUTED',
    'WORKFLOW_BLOCKED',
    'ARTIFACT_CREATED',
    'FEISHU_DOCUMENT_PUBLISHED',
    'FEISHU_DOCUMENT_PUBLICATION_FAILED',
    'WORKFLOW_COMPLETED',
    'WORK_ITEM_DELIVERED',
    'WORK_ITEM_FAILED',
    'WORK_ITEM_CANCELLED',
    'WORK_ITEM_INTERRUPTED',
]);
export const WorkItemEventSchema = z
    .object({
    id: EntityIdSchema,
    sequence: z.number().int().min(1),
    workItemId: EntityIdSchema,
    workflowRunId: EntityIdSchema.nullable(),
    stageRunId: EntityIdSchema.nullable(),
    type: EventTypeSchema,
    data: z.record(z.string(), z.unknown()),
    createdAt: IsoDateTimeSchema,
})
    .strict();
//# sourceMappingURL=events.js.map